import React from "react";
import { SectionTitle } from "@components";
import { useAppDispatch, useAppSelector } from "@hooks";
import { setCV } from "@store";
import { HeadingIds } from "@constants";
import { createCertificationNewPoint } from "@utils";
import { CertificationsNewList } from "./CertificationsNewList";
import { fields } from "./localization";
import commonStyles from "../../CV.common.scss";
export function CertificationsNew() {
    var _a;
    const dispatch = useAppDispatch();
    const { cv } = useAppSelector((state) => state.cv);
    const { language } = useAppSelector((state) => state.ui);
    const field = fields(language);
    const certificationsNew = ((_a = cv === null || cv === void 0 ? void 0 : cv.certificationsNewDisplay) === null || _a === void 0 ? void 0 : _a.length)
        ? cv.certificationsNewDisplay
        : [createCertificationNewPoint()];
    const setCertificationsNew = (certificationsNewDisplay) => {
        dispatch(setCV(Object.assign(Object.assign({}, cv), { certificationsNewDisplay })));
    };
    const handleAdd = () => {
        if (certificationsNew.length === 0) {
            setCertificationsNew([createCertificationNewPoint(), createCertificationNewPoint()]);
        }
        else {
            setCertificationsNew([...certificationsNew, createCertificationNewPoint()]);
        }
    };
    return (React.createElement("section", { id: HeadingIds.CertificationsNew, className: commonStyles.section },
        React.createElement(SectionTitle, { title: field.title, subtitle: field.subtitle, required: true, handleAdd: handleAdd, addButtonLabel: field.addCertification }),
        React.createElement(CertificationsNewList, { items: certificationsNew, onEdit: setCertificationsNew })));
}
